import { CSSProperties, ReactNode } from "react";
import Button from "../../Element/Button";
import ResponsiveImage from "../../Element/ResponsiveImage";
import { ImageCrop } from "../../Utility/dataTypes";
import styles from "./FloatingCta.module.css";

type CommonProps = {
  ariaLabel: string;
  href?: string;
  target?: HTMLAnchorElement["target"];
  placement?: "bottom-right" | "bottom-left";
  mobileUpOnly?: boolean;
};

export type FloatingCtaProps = CommonProps &
  (
    | { type: "image"; image: ImageCrop }
    | {
        type: "button";
        text: ReactNode;
        variant?: "primary" | "secondary" | "tertiary";
        icon?: ReactNode;
      }
  );

export default function FloatingCta({
  ariaLabel,
  href,
  target,
  placement = "bottom-right",
  mobileUpOnly,
  ...variantProps
}: FloatingCtaProps) {
  const style: CSSProperties & {
    "--floating-cta-mobile-display"?: string;
  } = {};

  if (mobileUpOnly) {
    style["--floating-cta-mobile-display"] = "none";
  }

  return (
    <div
      className={styles.container}
      style={style}
      data-placement={placement}
      data-layout-position="floatingcta"
    >
      {variantProps.type === "image" ? (
        <a
          className={styles.imageLink}
          href={href}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
          aria-label={ariaLabel}
        >
          <ResponsiveImage
            src={variantProps.image.src}
            srcWidth={variantProps.image.srcWidth}
            srcHeight={variantProps.image.srcHeight}
            alt={variantProps.image.alt}
          />
        </a>
      ) : (
        <Button
          href={href}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
          variant={variantProps.variant || "primary"}
          icon={variantProps.icon}
        >
          {variantProps.text}
        </Button>
      )}
    </div>
  );
}
